import {Entity} from "../commons/entity";
import {FX} from "./fx";
import {Role} from "./role";
/**
 * Created by Lauta on 13/2/2017.
 */

export class User implements Entity {

    public id: number = null;
    public username: string = "";
    public firstname: string = "";
    public lastname: string = "";
    public email: string = "";
    public enabled: boolean = true;
    public profilePhoto = '';
    public fxs: Array<FX> = null;
    public roles: Array<Role> = null;

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if(this.fxs) this.fxs = this.fxs.map(fx => new FX(fx));
        if(this.roles) this.roles = this.roles.map(role => new Role(role));
    }

    public addFxs(fxs: Array<FX>) {
        this.fxs.concat(fxs.filter(fx => !this.fxs.some(f => f.equals(fx))));
    }

    public removeFxs(fxs: Array<FX>) {
        this.fxs = this.fxs.filter(fx => !fxs.some(f => f.equals(fx)));
    }

    public getFullName(): string {
        return this.firstname + " " + this.lastname;
    }

    public hasFx(fxname: string): boolean {
        return this.fxs.some(fx => fx.fxname === fxname);
    }

}


// WEBPACK FOOTER //
// ./src/app/core/domain/user.ts